import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/lib/LanguageContext";
import SiteLayout from "@/components/SiteLayout";
import RouteAnalytics from "@/components/RouteAnalytics";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import PacificRentals from "@/pages/PacificRentals";
import VillaDetail from "@/pages/VillaDetail";
import MaintenanceConstruction from "@/pages/MaintenanceConstruction";
import Concierge from "@/pages/Concierge";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Testimonials from "@/pages/Testimonials";
import ShareExperience from "@/pages/ShareExperience";

const site = (el) => <SiteLayout>{el}</SiteLayout>;

function App() {
    return (
        <LanguageProvider>
            <div className="App">
                <BrowserRouter>
                    <RouteAnalytics />
                    <Toaster position="top-center" toastOptions={{ style: { fontFamily: "Montserrat" } }} />
                    <Routes>
                        <Route path="/" element={site(<Home />)} />
                        <Route path="/about" element={site(<About />)} />
                        <Route path="/services" element={site(<Services />)} />
                        <Route path="/pacific-rentals" element={site(<PacificRentals />)} />
                        <Route path="/pacific-rentals/:slug" element={site(<VillaDetail />)} />
                        <Route path="/maintenance-construction" element={site(<MaintenanceConstruction />)} />
                        <Route path="/concierge" element={site(<Concierge />)} />
                        <Route path="/contact" element={site(<Contact />)} />
                        <Route path="/testimonials" element={site(<Testimonials />)} />
                        <Route path="/share-your-experience" element={site(<ShareExperience />)} />

                        <Route path="/blog" element={site(<Blog />)} />
                        <Route path="/blog/:slug" element={site(<BlogArticle />)} />

                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin/dashboard" element={<AdminDashboard />} />
                        <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </div>
        </LanguageProvider>
    );
}

export default App;
